/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeAssistanceVisibility } from './EmployeeAssistanceVisibility';
import type { EmployeeExecutionBlocker } from './EmployeeExecutionBlocker';
/**
 * Blocking assistance record that still requires attention.
 */
export type OpenEmployeeAssistance = {
    /**
     * Stable identifier for this individual assistance incident.
     */
    assistanceId: string;
    /**
     * AI Agent associated with the latest assistance outcome.
     */
    employeeId: string;
    /**
     * AI Agent version used by the latest execution.
     */
    version: (number | 'DRAFT');
    /**
     * CRM conversation associated with the assistance, when available.
     */
    conversationId?: number;
    /**
     * CRM funnel containing the conversation, when available.
     */
    funnelId?: number;
    /**
     * Latest execution that changed this assistance record.
     */
    latestExecutionId: string;
    /**
     * Objective active when the assistance outcome occurred.
     */
    objective: string;
    /**
     * Audience allowed to see this assistance record.
     */
    visibility: EmployeeAssistanceVisibility;
    /**
     * Time when this assistance context first became open.
     */
    openedAt: string;
    /**
     * Time when the record last changed.
     */
    updatedAt: string;
    /**
     * Blocking impact discriminator.
     */
    impact: OpenEmployeeAssistance.impact;
    /**
     * Sanitized structured blocker from this blocked execution.
     */
    blocker: EmployeeExecutionBlocker;
    /**
     * Open lifecycle state.
     */
    status: OpenEmployeeAssistance.status;
};
export namespace OpenEmployeeAssistance {
    /**
     * Blocking impact discriminator.
     */
    export enum impact {
        BLOCKING = 'blocking',
    }
    /**
     * Open lifecycle state.
     */
    export enum status {
        OPEN = 'open',
    }
}

